import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import SidebarContext from "../../../context/SidebarContext";
import Header from "./Header";
import AddStoreStepper from "./AddStoreStepper";
import Catalogues from "./Steppers/Catalogues";
import StoreStepperContext from "../../../context/storeStepperContext";
import NewCatalog from "./Steppers/NewCatalogues";

function AddProduct() {
  const { open } = useContext(SidebarContext);
  const { checkForEdit } = useContext(StoreStepperContext);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "96vh",
          margin: "20px",
          marginRight: "0px",
          width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "12px",
        }}
      >
        <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
          <Header
            pageTitle={checkForEdit === true ? `Edit Product` : `Add Product`}
            currentRoute={
              checkForEdit === true ? `edit product` : `add product`
            }
          />
        </Box>
        <Box>
          {/* <Catalogues /> */}
          <NewCatalog />
        </Box>
      </Box>
    </>
  );
}

export default AddProduct;
